/*
 *  -----------------------------------------------------------------------
 *    <copyright file="schedule-bar.helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import {
    ISVTGroupedVersions,
    SVTScheduleVersionFields,
} from '@components/admin/schedule-versions-grid/schedule-versions-grid.interface';

const checkIfDuplicateExists = (arr: string[]) => new Set(arr).size !== arr.length;

// Returns Schedules that have Cohorts and Treatment Arms
export const SVTFilterFilledSchedules = (schedules: SVTScheduleVersionFields[]) =>
    schedules.filter((schedule) => schedule.cohortIds?.length && schedule.treatmentArmIds?.length);

export const SVTCheckIdsExist = (schedules: SVTScheduleVersionFields[], field: keyof SVTScheduleVersionFields) => {
    const indexOfEmptySchedule = schedules.findIndex((schedule) => !schedule[field]?.length);

    return indexOfEmptySchedule === -1;
};

export const SVTCheckUniqueIds = (schedules: SVTScheduleVersionFields[], field: keyof SVTScheduleVersionFields) => {
    const allIds: string[] = [];
    schedules.forEach((schedule) => {
        allIds.push(...schedule[field]);
    });

    return !checkIfDuplicateExists(allIds);
};

export const SVTCheckUniqueTAAndCohortCombination = (schedules: SVTScheduleVersionFields[]) => {
    const uniqueSchedules = schedules.filter((schedule) => {
        const notUniqueItemIndex = schedules.findIndex((item) => {
            const allIds = schedule.treatmentArmIds.concat(schedule.cohortIds, item.treatmentArmIds, item.cohortIds);
            const uniqueIds = allIds.filter((i) => allIds.filter((j) => i === j).length === 1);
            return !uniqueIds.length && schedule.id !== item.id;
        });

        return notUniqueItemIndex === -1;
    });

    return uniqueSchedules.length > 1;
};

export const SVTGetActiveSchedules = (groupedVersions: ISVTGroupedVersions) => {
    const groupsArray = Object.values(groupedVersions);
    const activeSchedules: SVTScheduleVersionFields[] = [];

    groupsArray.forEach((group) => {
        if (group[0].active) {
            activeSchedules.push(group[0]);
        }
    });

    return activeSchedules;
};
